import React, { ReactElement, useState } from 'react'
import { ArtData } from '@/database/art'
import Link from 'next/link'
import { cidv1FromCidv0Url, shortenAddress, shortenUrl } from '@/utils/shortenAddress'
import Image from 'next/image'
import { listing } from '@/utils/mapping'
import { copyToClipboard } from '@/utils/extras'
import { formatDate, formatDateString } from '@/utils/formatting'

const DetailsOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    const [showTooltip, setShowTooltip] = useState(false)
    const [showTooltip1, setShowTooltip1] = useState(false)
    const [showTooltip2, setShowTooltip2] = useState(false)
    const [showTooltip3, setShowTooltip3] = useState(false)
    const [showTooltip4, setShowTooltip4] = useState(false)
    const [showTooltip5, setShowTooltip5] = useState(false)

    return (
        <div>
            {artData && artData.art && (
                <div>
                    <p className="gray">
                        NFT:&nbsp;<span className="white">#{artData.tokenId}</span>
                    </p>
                    <p className="gray">
                        Art:&nbsp;<span className="white">#{artData.art.id}</span>
                    </p>
                    <p className="gray">
                        Title:&nbsp;<span className="white">{artData.art.title}</span>
                    </p>
                    <p className="gray">
                        Description:&nbsp;<span className="white">{artData.art.prompt}</span>
                    </p>
                    <p className="gray">
                        Original media:&nbsp;<></>
                        <span>
                            {artData.image?.url ? (
                                <span>
                                    <Image
                                        src="/hexagon-copy.svg"
                                        alt="arrow"
                                        width={15}
                                        height={15}
                                        style={{
                                            marginLeft: '1px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => copyToClipboard(artData.image.url, setShowTooltip)}
                                    />
                                    &nbsp;
                                    <Link href={cidv1FromCidv0Url(artData.image.url)}>
                                        <span className="white">{shortenUrl(artData.image.url)}</span>
                                        <span
                                            style={{
                                                visibility: showTooltip ? 'visible' : 'hidden',
                                                opacity: showTooltip ? 1 : 0,
                                                transition: 'opacity 0.5s ease-in-out',
                                            }}
                                        >
                                            &nbsp;Copied!
                                        </span>
                                    </Link>
                                </span>
                            ) : (
                                '-'
                            )}
                        </span>
                    </p>
                    <p className="gray">
                        Metadata:&nbsp;<></>
                        <span>
                            {artData.nft?.metadataUri ? (
                                <span>
                                    <Image
                                        src="/hexagon-copy.svg"
                                        alt="arrow"
                                        width={15}
                                        height={15}
                                        style={{
                                            marginLeft: '1px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => copyToClipboard(artData.nft?.metadataUri, setShowTooltip)}
                                    />
                                    &nbsp;
                                    <Link href={cidv1FromCidv0Url(artData.nft.metadataUri)}>
                                        <span className="white">{shortenUrl(artData.nft.metadataUri)}</span>
                                        <span
                                            style={{
                                                visibility: showTooltip ? 'visible' : 'hidden',
                                                opacity: showTooltip ? 1 : 0,
                                                transition: 'opacity 0.5s ease-in-out',
                                            }}
                                        >
                                            &nbsp;Copied!
                                        </span>
                                    </Link>
                                </span>
                            ) : (
                                '-'
                            )}
                        </span>
                    </p>
                    <p className="gray">
                        X&nbsp;Airdrop:&nbsp;<></>
                        <span>
                            <Link
                                href={
                                    artData.art.x
                                        ? `https://twitter.com/yourtokenart/status/${artData.art.x}`
                                        : 'https://twitter.com/yourtokenart'
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {shortenUrl(
                                    artData.art.x
                                        ? `https://twitter.com/yourtokenart/status/${artData.art.x}`
                                        : 'https://twitter.com/yourtokenart',
                                )}
                            </Link>
                        </span>
                    </p>
                    <p className="gray">
                        Listing:&nbsp;<span className="white">{listing(artData)}</span>
                    </p>
                    <p className="gray">
                        Contract Address:
                        <Image
                            src="/hexagon-copy.svg"
                            alt="arrow"
                            width={15}
                            height={15}
                            style={{
                                marginLeft: '1px',
                                cursor: 'pointer',
                            }}
                            onClick={() => copyToClipboard(artData.nft?.contractAddress, setShowTooltip1)}
                        />
                        &nbsp;
                        <span className="white">{shortenAddress(artData.nft?.contractAddress)}</span>
                        <span
                            style={{
                                visibility: showTooltip1 ? 'visible' : 'hidden',
                                opacity: showTooltip1 ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        >
                            &nbsp;Copied!
                        </span>
                    </p>
                    <p className="gray">
                        Token Standard:&nbsp;
                        <span className="white">{'ERC-721'}</span>
                    </p>
                    <p className="gray">
                        Chain:&nbsp;
                        <span className="white">{'PulseChain'}</span>
                    </p>
                    <p className="gray">
                        Owner:
                        <Image
                            src="/hexagon-copy.svg"
                            alt="arrow"
                            width={15}
                            height={15}
                            style={{
                                marginLeft: '1px',
                                cursor: 'pointer',
                            }}
                            onClick={() => copyToClipboard(artData.art.currentOwner, setShowTooltip2)}
                        />
                        &nbsp;
                        <span className="white">{shortenAddress(artData.art.currentOwner)}</span>
                        <span
                            style={{
                                visibility: showTooltip2 ? 'visible' : 'hidden',
                                opacity: showTooltip2 ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        >
                            &nbsp;Copied!
                        </span>
                    </p>
                    <p className="gray">
                        Creator:&nbsp;
                        <Image
                            src="/hexagon-copy.svg"
                            alt="arrow"
                            width={15}
                            height={15}
                            style={{
                                marginLeft: '1px',
                                cursor: 'pointer',
                            }}
                            onClick={() => copyToClipboard(artData.art.user.walletAddress, setShowTooltip3)}
                        />
                        &nbsp;
                        <span className="white">{shortenAddress(artData.art.user.walletAddress)}</span>
                        <span
                            style={{
                                visibility: showTooltip3 ? 'visible' : 'hidden',
                                opacity: showTooltip3 ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        >
                            &nbsp;Copied!
                        </span>
                    </p>
                    <p className="gray">
                        Vault wallet:&nbsp;
                        <Image
                            src="/hexagon-copy.svg"
                            alt="arrow"
                            width={15}
                            height={15}
                            style={{
                                marginLeft: '1px',
                                cursor: 'pointer',
                            }}
                            onClick={() => copyToClipboard(artData.nft?.vaultWallet.address, setShowTooltip4)}
                        />
                        &nbsp;
                        <span className="white">{shortenAddress(artData.nft?.vaultWallet.address)}</span>
                        <span
                            style={{
                                visibility: showTooltip4 ? 'visible' : 'hidden',
                                opacity: showTooltip4 ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        >
                            &nbsp;Copied!
                        </span>
                    </p>
                    <p className="gray">
                        Personal wallet:&nbsp;
                        <Image
                            src="/hexagon-copy.svg"
                            alt="arrow"
                            width={15}
                            height={15}
                            style={{
                                marginLeft: '1px',
                                cursor: 'pointer',
                            }}
                            onClick={() => copyToClipboard(artData.nft?.personalWallet.address, setShowTooltip5)}
                        />
                        &nbsp;
                        <span className="white">{shortenAddress(artData.nft?.personalWallet.address)}</span>
                        <span
                            style={{
                                visibility: showTooltip5 ? 'visible' : 'hidden',
                                opacity: showTooltip5 ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        >
                            &nbsp;Copied!
                        </span>
                    </p>
                    <p className="gray">
                        <span>Created&nbsp;at:&nbsp;</span>
                        <span className="white">{formatDateString(artData.art.createdAt)}</span>
                    </p>
                    <p className="gray">
                        <span>Minted&nbsp;at:&nbsp;</span>
                        <span className="white">{artData.nft?.mintedAt && formatDate(artData.nft?.mintedAt)}</span>
                    </p>
                </div>
            )}
        </div>
    )
}

export default DetailsOverview
